import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { ICertificate } from '../interface/ICertificate';
import { IPerson } from '../interface/IPerson';
import { IOrder } from '../interface/IOrder';
import { IEvent } from '../interface/IEvent';
import { ILocation } from '../interface/ILocation';
import { ISession } from '../interface/ISession';
import { IOrderDetails } from '../interface/IOrderDetails';
import { IPagination } from '../interface/IPganationData';

const GetUrl = () => {
    switch (window.location.host) {
        case 'localhost:44449':
            // return 'https://www.ticketspulse.ru/';
            return 'https://test.ticketspulse.ru/';
        case 'ticketspulse.ru':
            return 'https://test.ticketspulse.ru/';
        case 'https://192.168.4.13:49196':
            return 'https://test.ticketspulse.ru/';
        default:
            return 'https://www.ticketspulse.ru/';
    }
}

const getTenant = () => {
    switch (window.location.host) {
        case 'localhost:44449':
            return 'ddf7ee08-19e0-4a0a-b953-64eb2f9b43f8';
        case '192.168.4.13:44449':
            return 'ddf7ee08-19e0-4a0a-b953-64eb2f9b43f8';
        case '10.10.163.46:44449':
            return 'ddf7ee08-19e0-4a0a-b953-64eb2f9b43f8';
        default:
            return '621da32c-a4a9-400f-be33-73fdcc20e12f';
    }
}
const getDistributor = () => {
    console.log(window.location.host)
    switch (window.location.host) {
        case 'localhost:44449':
            return '585498ce-52d1-46bb-b3e7-6f91dbc92cd7';
        case '192.168.4.13:44449':
            return '585498ce-52d1-46bb-b3e7-6f91dbc92cd7';
        case '10.10.163.46:44449':
            return '585498ce-52d1-46bb-b3e7-6f91dbc92cd7';
        default:
            return '3a2c2f37-9b4e-48a6-8098-6b33059e988';
    }
}
export const CallTPApi = createApi({
    reducerPath: 'callTPApi',
    baseQuery: fetchBaseQuery({
        baseUrl: GetUrl(),
        // baseUrl: 'https://www.ticketspulse.ru:30443/',
        // baseUrl: 'http://localhost:5077/',
        prepareHeaders: (headers, { getState }: { getState: any }) => {
            const token = getState().tokenTP?.value as any;
            const tokenAuthentication = getState().tokenAuthenticationTP?.value as any;
            const tenantId = getTenant()
            const distributorId = getDistributor()
            headers.set("Authorization", `Bearer ${token || tokenAuthentication}`);
            if (tenantId) {
                headers.set("X-TenantId", `${tenantId}`);
            }
            if (distributorId) {
                headers.set("X-DistributorId", `${distributorId}`);
            }
            return headers;
        },
    }),
    keepUnusedDataFor: 0,
    // global configuration for the api
    refetchOnMountOrArgChange: 0,
    endpoints: (builder) => ({
        getEventSessions: builder.query<IPagination, any>({ query: (parm: any) => ({ url: `api/events/${parm.id}/sessions?${parm.startDate ? `startDate=${parm.startDate}${parm.endDate ? `&endDate=${parm.endDate}` : ""}` : ""}` }) }),
        postLogin: builder.mutation<any, any>({ query: (body) => ({ url: 'auth/login', method: 'POST', body }) }),
        postSetOrderStatus: builder.mutation<any, any>({ query: (formData: any) => ({ url: `/api/orders/${formData.id}/setstatus`, method: 'POST', body: formData.status }) }),
        postUserToken: builder.mutation<any, any>({ query: () => ({ url: 'api/UserToken/authorize', method: 'POST' }) }),
        postRegisterPhone: builder.mutation<any, any>({ query: (body) => ({ url: 'auth/registerphone', method: 'POST', body }) }),
        postSmsLogin: builder.mutation<any, any>({ query: (body) => ({ url: 'auth/smslogin', method: 'POST', body }) }),
        getPersonWhoami: builder.query<any, void>({ query: () => ({ url: 'api/persons/whoami', method: 'GET' }) }),
        getPersonWhoamiData: builder.mutation<any, void>({ query: () => ({ url: 'api/persons/whoami', method: 'GET' }) }),
        postOrder: builder.mutation<any, any>({ query: (formData: any) => ({ url: `/api/orders`, method: 'POST', body: formData }) }),
        getOrder: builder.mutation<any, any>({ query: (id: string) => ({ url: `/api/orders/${id}`, method: 'GET' }) }),
        putOrder: builder.mutation<any, any>({ query: (formData: any) => ({ url: `/api/orders/${formData.id}`, method: 'PUT', body: formData }) }),
        postOrderItem: builder.mutation<any, any>({ query: (formData: any) => ({ url: `/api/orderitems`, method: 'POST', body: formData }) }),
        postOrderBankLink: builder.mutation<any, any>({ query: (body: any) => ({ url: `/api/orders/${body.id}/banklink?bank=ABR2`, responseHandler: (response) => response.text(), method: `POST`, body: body }) }),
        // postOrderBankLink: builder.mutation<any, any>({ query: (body: any) => ({ url: `/api/orders/${body.id}/banklink?bank=ABR2${body.typeRid !== null ? `&typeRid=${body.typeRid}` : ""}`, responseHandler: (response) => response.text(), method: `POST`, body: body }) }),
        postCertificate: builder.mutation<any, ICertificate | null>({ query: (body) => ({ url: `/api/certificates`, body: body, method: 'POST' }) }),
        putPerson: builder.mutation<any, IPerson>({ query: (body: IPerson) => ({ url: `/api/persons/${body.id}`, method: 'PUT', body }) }),
        deleteOrderItem: builder.mutation<any, any>({ query: (id: string) => ({ url: `/api/orderitems/${id}`, method: 'DELETE' }) }),
        getEvent: builder.query<IEvent, string>({ query: (id: string) => ({ url: `api/events/${id}` }) }),
        getLocationScheme: builder.query<ILocation, string>({ query: (id: string) => ({ url: `api/locations/${id}/scheme` }) }),
        getOrderItems: builder.mutation<any, any>({ query: (id: string) => ({ url: `/api/orders/${id}/items` }) }),
        getSessionAssignments: builder.query<any, any>({ query: (id: string) => ({ url: `api/sessions/${id}/assignments` }) }),
        getSession: builder.query<ISession, any>({ query: (id: string) => ({ url: `api/sessions/${id}` }) }),
        getSesssionPriceCategories: builder.query<any, any>({ query: (id: string) => ({ url: `api/sessions/${id}/pricecategories` }) }),
        postBasketClear: builder.mutation<any, any>({ query: (id: string) => ({ url: `/api/orders/${id}/clear`, method: 'POST' }) }),
        getCertificates: builder.query<any, any>({ query: ({ term, page, size, status }) => ({ url: `/api/certificates`, params: { ...(term && { term }), page, pagesize: size, ...(status && { status }) } }) }),
        getCertificate: builder.query<ICertificate, string>({ query: (id: string) => ({ url: `/api/certificates/${id}` }) }),
        getCertificateData: builder.mutation<ICertificate, string>({ query: (id: string) => ({ url: `/api/certificates/${id}` }) }),
        getOrderDetailsData: builder.mutation<IOrderDetails, any>({ query: ({ id, tenantId }: { id: string, tenantId?: string }) => ({ url: `/api/orders/${id}/details`, headers: { "X-TenantId": tenantId } }) }),
        getOrderLink: builder.mutation<any, any>({ query: (body: any) => ({ url: `/api/orders/${body.id}/banklink?bank=ABR2`, responseHandler: (response) => response.text(), method: `POST`, body: body }) }),
        getSessionAssignmentsMutation: builder.mutation<any, any>({ query: (id: string) => ({ url: `api/sessions/${id}/assignments` }) }),
        postAddCertToOrder: builder.mutation<any, any>({ query: (body) => ({ url: `/api/Orders/${body.id}/addcertificate`, method: 'POST', body: body }) }),
        postCertificateFind: builder.mutation<any, any>({ query: (body) => ({ url: `/api/certificates/find`, method: 'POST', body: body }) }),
        deleteCertFromOrder: builder.mutation<any, any>({ query: (body) => ({ url: `/api/Orders/${body.id}/deletecertificate`, method: 'POST', body: body }) }),
    }),
})

export const {
    usePostLoginMutation,
    usePostUserTokenMutation,
    usePostRegisterPhoneMutation,
    usePostSmsLoginMutation,
    useGetPersonWhoamiQuery,
    useGetPersonWhoamiDataMutation,
    usePostOrderMutation,
    usePutOrderMutation,
    usePostOrderItemMutation,
    usePostOrderBankLinkMutation,
    usePostCertificateMutation,
    usePutPersonMutation,
    usePostSetOrderStatusMutation,
    useGetOrderMutation,
    useDeleteOrderItemMutation,
    useGetEventQuery,
    useGetLocationSchemeQuery,
    useGetOrderItemsMutation,
    useGetSessionAssignmentsQuery,
    useGetSessionQuery,
    useGetSesssionPriceCategoriesQuery,
    usePostBasketClearMutation,
    useGetCertificatesQuery,
    useGetCertificateQuery,
    useGetCertificateDataMutation,
    useGetOrderDetailsDataMutation,
    useGetOrderLinkMutation,
    useGetSessionAssignmentsMutationMutation,
    usePostAddCertToOrderMutation,
    usePostCertificateFindMutation,
    useGetEventSessionsQuery,
    useDeleteCertFromOrderMutation,
} = CallTPApi